import { render, staticRenderFns } from "./ReadyToSanitize.vue?vue&type=template&id=4f7c0b15&"
import script from "./ReadyToSanitize.vue?vue&type=script&lang=js&"
export * from "./ReadyToSanitize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports